import {
  SwapWidgetThemeColorVariables,
  SwapWidgetBorderRadiusSize
} from "../../widgetTypes";

export enum WidgetBorderRadiusCSSVariables {
  Container = "--container-border-radius",
  Button = "--button-border-radius",
  SwapForm = "--swap-form-border-radius",
  Modal = "--modal-border-radius"
}

export const WIDGET_THEME_COLOR_VARIABLES: {
  [key in keyof Required<SwapWidgetThemeColorVariables>]: string;
} = {
  widgetBg: "--widget-bg",
  headerButtonBg: "--header-button-bg",
  headerButtonText: "--header-button-text",
  headerTitle: "--header-title",
  containerButtonBg: "--container-button-bg",
  containerButtonText: "--container-button-text",
  iframeBg: "--iframe-bg"
} as const;

export const WIDGET_BORDER_RADIUS_SIZE: {
  [widgetBorderRadiusCSSVariablesKey in WidgetBorderRadiusCSSVariables]: {
    [widgetBorderRadiusSizeKey in SwapWidgetBorderRadiusSize]: string;
  };
} = {
  [WidgetBorderRadiusCSSVariables.Container]: {
    [SwapWidgetBorderRadiusSize.None]: "0",
    [SwapWidgetBorderRadiusSize.Small]: "18px",
    [SwapWidgetBorderRadiusSize.Medium]: "24px",
    [SwapWidgetBorderRadiusSize.Large]: "32px"
  },
  [WidgetBorderRadiusCSSVariables.SwapForm]: {
    [SwapWidgetBorderRadiusSize.None]: "0",
    [SwapWidgetBorderRadiusSize.Small]: "12px",
    [SwapWidgetBorderRadiusSize.Medium]: "16px",
    [SwapWidgetBorderRadiusSize.Large]: "24px"
  },
  [WidgetBorderRadiusCSSVariables.Modal]: {
    [SwapWidgetBorderRadiusSize.None]: "0",
    [SwapWidgetBorderRadiusSize.Small]: "14px",
    [SwapWidgetBorderRadiusSize.Medium]: "20px",
    [SwapWidgetBorderRadiusSize.Large]: "28px"
  },
  [WidgetBorderRadiusCSSVariables.Button]: {
    [SwapWidgetBorderRadiusSize.None]: "0",
    [SwapWidgetBorderRadiusSize.Small]: "4px",
    [SwapWidgetBorderRadiusSize.Medium]: "8px",
    [SwapWidgetBorderRadiusSize.Large]: "24px"
  }
} as const;
